export const formatCurrencyUSD = value =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);



// WEBPACK FOOTER //
// ./src/utils/currency.js